/* eslint-disable max-len */
import {inputType} from '../../../../../pages/esgManager/interface/inputType';
import {getYearDropdownOptions} from '../../commonConstants';

export const pillers = {
  realEstateGovernance: 'pillar_governance',
  realEstateStrategy: 'pillar_strategy',
  realEstateRiskManagement: 'pillar_risk_management',
  realEstateMetricsTargets: 'pillar_metrics_targets'
};

export const REAL_ESTATE_FIELD_NAMES = {
  RES_QG1_Q1_VALUE: 'resQg1Q1_value',
  RES_QG1_Q1_COMMENT: 'resQg1Q1_comment',
  RES_QG1_Q2_VALUE: 'resQg1Q2_value',
  RES_QG1_Q2_COMMENT: 'resQg1Q2_comment',

  RES_QG2_Q1_VALUE: 'resQg2Q1_value',
  RES_QG2_Q1_COMMENT: 'resQg2Q1_comment',
  RES_QG2_Q2_VALUE: 'resQg2Q2_value',
  RES_QG2_Q2_COMMENT: 'resQg2Q2_comment',

  RES_QG3_Q1_VALUE: 'resQg3Q1_value',
  RES_QG3_Q1_COMMENT: 'resQg3Q1_comment',
  RES_QG3_Q2_VALUE: 'resQg3Q2_value',
  RES_QG3_Q2_COMMENT: 'resQg3Q2_comment',

  RES_QG4_Q1_VALUE: 'resQg4Q1_value',
  RES_QG4_Q1_COMMENT: 'resQg4Q1_comment',
  RES_QG4_Q2_VALUE: 'resQg4Q2_value',
  RES_QG4_Q2_COMMENT: 'resQg4Q2_comment',

  RES_QG5_Q1_VALUE: 'resQg5Q1_value',
  RES_QG5_Q1_COMMENT: 'resQg5Q1_comment',
  RES_QG5_Q2_VALUE: 'resQg5Q2_value',
  RES_QG5_Q2_COMMENT: 'resQg5Q2_comment',

  RES_QG6_Q1_VALUE: 'resQg6Q1_value',
  RES_QG6_Q1_COMMENT: 'resQg6Q1_comment',
  RES_QG6_Q2_VALUE: 'resQg6Q2_value',
  RES_QG6_Q2_COMMENT: 'resQg6Q2_comment',
  RES_QG6_Q3_VALUE: 'resQg6Q3_value',
  RES_QG6_Q3_COMMENT: 'resQg6Q3_comment',

  RES_QG7_Q1_VALUE: 'resQg7Q1_value',
  RES_QG7_Q1_COMMENT: 'resQg7Q1_comment',
  RES_QG7_Q2_VALUE: 'resQg7Q2_value',
  RES_QG7_Q2_COMMENT: 'resQg7Q2_comment',
  RES_QG7_Q3_VALUE: 'resQg7Q3_value',
  RES_QG7_Q3_COMMENT: 'resQg7Q3_comment',

  RES_QG8_Q1_VALUE: 'resQg8Q1_value',
  RES_QG8_Q1_COMMENT: 'resQg8Q1_comment',
  RES_QG8_Q2_VALUE: 'resQg8Q2_value',
  RES_QG8_Q2_COMMENT: 'resQg8Q2_comment',
  RES_QG8_Q3_VALUE: 'resQg8Q3_value',
  RES_QG8_Q3_COMMENT: 'resQg8Q3_comment',

  RES_QG9_Q1_VALUE: 'resQg9Q1_value',
  RES_QG9_Q1_COMMENT: 'resQg9Q1_comment',
  RES_QG9_Q2_VALUE: 'resQg9Q2_value',
  RES_QG9_Q2_COMMENT: 'resQg9Q2_comment',
  RES_QG9_Q3_VALUE: 'resQg9Q3_value',
  RES_QG9_Q3_COMMENT: 'resQg9Q3_comment',

  RES_QG10_Q1_VALUE: 'resQg10Q1_value',
  RES_QG10_Q1_COMMENT: 'resQg10Q1_comment',
  RES_QG10_Q2_VALUE: 'resQg10Q2_value',
  RES_QG10_Q2_COMMENT: 'resQg10Q2_comment',
  RES_QG10_Q3_VALUE: 'resQg10Q3_value',
  RES_QG10_Q3_COMMENT: 'resQg10Q3_comment',

  RES_QG11_Q1_VALUE: 'resQg11Q1_value',
  RES_QG11_Q1_COMMENT: 'resQg11Q1_comment',
  RES_QG11_Q2_VALUE: 'resQg11Q2_value',
  RES_QG11_Q2_COMMENT: 'resQg11Q2_comment',
  RES_QG11_Q3_VALUE: 'resQg11Q3_value',
  RES_QG11_Q3_COMMENT: 'resQg11Q3_comment'
} as const;

const RealEstateQuestions = {
  QUESTION_GROUP_1: {
    KEY: '1',
    NAME: '1. Does the board oversee climate-related risks and opportunities?',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG1_Q1_VALUE,
        fieldLabel:
          'Q1.1 What is the board’s role in guiding portfolio resilience strategies for properties exposed to physical climate risks?',
        Question:
          'Q1.1 What is the board’s role in guiding portfolio resilience strategies for properties exposed to physical climate risks?',
        tooltip: '',
        options: [
          'Included in formal governance charter',
          'Reviewed annually',
          'Reviewed quarterly',
          'Not reviewed'
        ]
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG1_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG1_Q2_VALUE,
        fieldLabel:
          'Q1.2 How frequently does the board review green building performance metrics?',
        Question:
          'Q1.2 How frequently does the board review green building performance metrics?',
        tooltip: '',
        options: ['Monthly', 'Quarterly', 'Annually', 'Never']
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG1_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_2: {
    KEY: '2',
    NAME: '2. What is management’s role in assessing and managing climate-related risks and opportunities?',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG2_Q1_VALUE,
        fieldLabel:
          'Q2.1 What role does executive management play in integrating ESG into asset development cycles?',
        Question:
          'Q2.1 What role does executive management play in integrating ESG into asset development cycles?',
        tooltip: '',
        options: [
          'Set climate goals',
          'Monitor project ESG compliance',
          'Approve transition budgets',
          'Conduct site-level risk assessments'
        ]
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG2_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG2_Q2_VALUE,
        fieldLabel:
          'Q2.2 Is climate scenario planning used in land acquisition strategies?',
        Question:
          'Q2.2 Is climate scenario planning used in land acquisition strategies?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG2_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_3: {
    KEY: '3',
    NAME: '3. Climate risks and opportunities identified over short, medium, and long term:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG3_Q1_VALUE,
        fieldLabel:
          'Q3.1 What are the long‑term risks from rising insurance premiums and asset devaluation due to extreme weather?',
        Question:
          'Q3.1 What are the long‑term risks from rising insurance premiums and asset devaluation due to extreme weather?',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG3_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG3_Q2_VALUE,
        fieldLabel:
          'Q3.2 Are there opportunities in green‑certified residential or commercial developments?',
        Question:
          'Q3.2 Are there opportunities in green‑certified residential or commercial developments?',
        tooltip: '',
        options: ['Residential', 'Commercial', 'Both', 'Not applicable']
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG3_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_4: {
    KEY: '4',
    NAME: '4. Strategic impacts of climate risks/opportunities:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG4_Q1_VALUE,
        fieldLabel:
          'Q4.1 How are heat stress, water stress, and flooding affecting financial planning for asset development?',
        Question:
          'Q4.1 How are heat stress, water stress, and flooding affecting financial planning for asset development?',
        tooltip: ''
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG4_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG4_Q2_VALUE,
        fieldLabel:
          'Q4.2 What revenue implications are expected from stricter building codes and tenant sustainability demands?',
        Question:
          'Q4.2 What revenue implications are expected from stricter building codes and tenant sustainability demands?',
        tooltip: '',
        options: [
          'Capex increases',
          'Increased rents',
          'Longer payback periods'
        ]
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG4_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_5: {
    KEY: '5',
    NAME: '5. Resilience under 2 °C or lower scenarios:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG5_Q1_VALUE,
        fieldLabel:
          'Q5.1 Are adaptation costs modeled under 4 °C warming scenarios?',
        Question:
          'Q5.1 Are adaptation costs modeled under 4 °C warming scenarios?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG5_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG5_Q2_VALUE,
        fieldLabel:
          'Q5.2 How resilient are portfolios to sea‑level rise, heat islands, or water shortages?',
        Question:
          'Q5.2 How resilient are portfolios to sea‑level rise, heat islands, or water shortages?',
        tooltip: '',
        options: [
          'Fully stress‑tested',
          'Partial analysis complete',
          'No analysis yet'
        ]
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG5_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_6: {
    KEY: '6',
    NAME: '6. Risk identification and assessment processes:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG6_Q1_VALUE,
        fieldLabel:
          'Q6.1 What tools/methods are used to identify risks across the value chain?',
        Question:
          'Q6.1 What tools/methods are used to identify risks across the value chain?',
        tooltip: '',
        options: [
          'GIS & mapping',
          'Facility audits',
          'Insurance loss modeling',
          'None of the above'
        ]
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG6_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG6_Q2_VALUE,
        fieldLabel:
          'Q6.2 Are both physical and transition risks assessed for each asset or geography?',
        Question:
          'Q6.2 Are both physical and transition risks assessed for each asset or geography?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG6_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG6_Q3_VALUE,
        fieldLabel: 'Q6.3 How are risks prioritized?',
        Question: 'Q6.3 How are risks prioritized?',
        tooltip: '',
        options: [
          'Revenue impact',
          'Operational disruption',
          'Regulatory risks',
          'Market access'
        ]
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG6_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_7: {
    KEY: '7',
    NAME: '7. Risk management processes:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG7_Q1_VALUE,
        fieldLabel: 'Q7.1 How are mitigation strategies evaluated?',
        Question: 'Q7.1 How are mitigation strategies evaluated?',
        tooltip: '',
        options: [
          'Adaptation plans',
          'Insurance coverage',
          'Energy transition initiatives'
        ]
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG7_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG7_Q2_VALUE,
        fieldLabel:
          'Q7.2 Are climate-linked risks included in investment reviews or plant upgrades?',
        Question:
          'Q7.2 Are climate-linked risks included in investment reviews or plant upgrades?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG7_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG7_Q3_VALUE,
        fieldLabel:
          'Q7.3 Are procurement/development projects evaluated for climate resilience?',
        Question:
          'Q7.3 Are procurement/development projects evaluated for climate resilience?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG7_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_8: {
    KEY: '8',
    NAME: '8. Integration into enterprise-wide risk management:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG8_Q1_VALUE,
        fieldLabel: 'Q8.1 Are climate risks integrated into ERM dashboards?',
        Question: 'Q8.1 Are climate risks integrated into ERM dashboards?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG8_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG8_Q2_VALUE,
        fieldLabel: 'Q8.2 Is there a separate climate risk register?',
        Question: 'Q8.2 Is there a separate climate risk register?',
        tooltip: '',
        options: ['Yes', 'Tagged in operational register', 'No register']
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG8_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG8_Q3_VALUE,
        fieldLabel: 'Q8.3 How is risk escalation triggered for climate events?',
        Question: 'Q8.3 How is risk escalation triggered for climate events?',
        tooltip: '',
        options: [
          'Heat stress thresholds',
          'Flood/insurance loss exceedance',
          'Compliance trigger',
          'Manual override'
        ]
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG8_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_9: {
    KEY: '9',
    NAME: '9. Climate-related metrics:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.CHECKBOXGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG9_Q1_VALUE,
        fieldLabel:
          'Q9.1 What GHG intensity or energy‑use metrics are tracked?',
        Question: 'Q9.1 What GHG intensity or energy‑use metrics are tracked?',
        tooltip: '',
        options: [
          'CO₂ / m² built area',
          'Energy use per MWh',
          'Energy Star ratings',
          'LEED / BREEAM metrics'
        ]
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG9_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG9_Q2_VALUE,
        fieldLabel: 'Q9.2 Are water‑stress or land‑use metrics monitored?',
        Question: 'Q9.2 Are water‑stress or land‑use metrics monitored?',
        tooltip: '',
        options: ['Yes – water stress', 'Yes – land‑use', 'No']
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG9_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG9_Q3_VALUE,
        fieldLabel:
          'Q9.3 Are there KPIs for climate‑aligned R&D or green‑revenue share?',
        Question:
          'Q9.3 Are there KPIs for climate‑aligned R&D or green‑revenue share?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG9_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_10: {
    KEY: '10',
    NAME: '10. GHG emissions disclosures:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG10_Q1_VALUE,
        fieldLabel:
          'Q10.1 Are Scope 1 and 2 emissions disclosed for all facilities?',
        Question:
          'Q10.1 Are Scope 1 and 2 emissions disclosed for all facilities?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG10_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.CHECKBOXGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG10_Q2_VALUE,
        fieldLabel: 'Q10.2 Are Scope 3 emissions disclosed for the following?',
        Question: 'Q10.2 Are Scope 3 emissions disclosed for the following?',
        tooltip: '',
        options: [
          'Upstream inputs',
          'Embodied carbon in construction',
          'Tenant usage',
          'Not disclosed'
        ]
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG10_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG10_Q3_VALUE,
        fieldLabel: 'Q10.3 Are emissions verified via third‑party assurance?',
        Question: 'Q10.3 Are emissions verified via third‑party assurance?',
        tooltip: '',
        options: ['Yes', 'No']
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG10_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  },

  QUESTION_GROUP_11: {
    KEY: '11',
    NAME: '11. Targets and tracking:',
    QUESTIONS: {
      QUESTION_1: {
        fieldType: inputType.SELECT,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG11_Q1_VALUE,
        fieldLabel:
          'Q11.1 What is the company’s net‑zero or emissions‑reduction target year?',
        Question:
          'Q11.1 What is the company’s net‑zero or emissions‑reduction target year?',
        tooltip: '',
        options: getYearDropdownOptions()
      },
      QUESTION_1_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG11_Q1_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_2: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG11_Q2_VALUE,
        fieldLabel:
          'Q11.2 How is the performance against annual emissions or efficiency goals tracked?',
        Question:
          'Q11.2 How is the performance against annual emissions or efficiency goals tracked?',
        tooltip: '',
        options: [
          'Annual public reporting',
          'Internal dashboards only',
          'Third‑party verification'
        ]
      },
      QUESTION_2_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG11_Q2_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      },
      QUESTION_3: {
        fieldType: inputType.RADIOGROUP,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG11_Q3_VALUE,
        fieldLabel:
          'Q11.3 Are targets science‑based or aligned with SBTi / sectoral pathways?',
        Question:
          'Q11.3 Are targets science‑based or aligned with SBTi / sectoral pathways?',
        tooltip: '',
        options: ['Yes – SBTi validated', 'Aligned, not validated', 'No']
      },
      QUESTION_3_COMMENT: {
        fieldType: inputType.TEXTAREA,
        fieldName: REAL_ESTATE_FIELD_NAMES.RES_QG11_Q3_COMMENT,
        fieldLabel: 'Comment',
        Question: '',
        tooltip: ''
      }
    }
  }
};

export default RealEstateQuestions;
